import {
  createAction,
  type Meta,
  type OptionalLegacyActionCreator,
  type RequiredLegacyActionCreator,
} from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from 'app-components/flux/core/resourceStoreTypes';

import type { Milestone, MilestoneNotificationPayload, MilestoneProps } from './milestonesTypes';

export const GET_MILESTONES = 'GET_MILESTONES';
export const GET_MILESTONES_SUCCESS = 'GET_MILESTONES_SUCCESS';
export const GET_MILESTONES_FAILURE = 'GET_MILESTONES_FAILURE';
export const UPDATE_MILESTONE = 'UPDATE_MILESTONE';
export const MILESTONE_RECEIVED_ACTION = 'MILESTONE_RECEIVED_ACTION';

type MilestoneMeta = Meta<MilestoneProps>;

export const getMilestones: OptionalLegacyActionCreator<undefined, MilestoneMeta> = createAction<
  undefined,
  MilestoneMeta
>(GET_MILESTONES);
export const getMilestonesSuccess: RequiredLegacyActionCreator<
  QcsSyncResourcesPayload<MilestoneProps>,
  MilestoneMeta
> = createAction<QcsSyncResourcesPayload<MilestoneProps>, MilestoneMeta>(GET_MILESTONES_SUCCESS);
export const getMilestonesFailure: RequiredLegacyActionCreator<unknown, MilestoneMeta> = createAction<
  unknown,
  MilestoneMeta
>(GET_MILESTONES_FAILURE);

export const updateMilestone = createAction<Milestone[], MilestoneMeta>(
  UPDATE_MILESTONE,
  (payload) => payload,
  (_payload, metadata) => metadata,
);

export const milestoneReceivedNotification = createAction<MilestoneNotificationPayload, MilestoneMeta>(
  MILESTONE_RECEIVED_ACTION,
  (payload) => payload,
);
